const EmailObfuscate = ({ email }:any) => {
  // დაშლა პირველად მონაცემებად
  const parts = email.split('@');
  const username = parts[0];
  const domainParts = parts[1].split('.');
  const domainName = domainParts[0];
  const extension = domainParts[1];
  
  return (
    <span>
      {username}
      {/* @ სიმბოლო ხილულად ჩანს, მაგრამ HTML-ში დაშლილია */}
      <span>@</span>
      {domainName}
      {/* . სიმბოლო ხილულად ჩანს, მაგრამ HTML-ში დაშლილია */}
      <span>.</span>
      {extension}
    </span>
  );
};

export default EmailObfuscate;